import { render, staticRenderFns } from "./DocumentDeleteButton.vue?vue&type=template&id=62ae99bb&scoped=true"
import script from "./DocumentDeleteButton.vue?vue&type=script&lang=js"
export * from "./DocumentDeleteButton.vue?vue&type=script&lang=js"
import style0 from "./DocumentDeleteButton.vue?vue&type=style&index=0&id=62ae99bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae99bb",
  null
  
)

export default component.exports